import { render } from "./WeeklyTarget.vue?vue&type=template&id=34e1c737"
import script from "./WeeklyTarget.vue?vue&type=script&lang=js"
export * from "./WeeklyTarget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__